// extracted by mini-css-extract-plugin
export var body = "resourceCard-module--body--3e269";
export var button = "resourceCard-module--button--181a5";
export var buttonTexts = "resourceCard-module--button-texts--34c91";
export var card = "resourceCard-module--card--29993";
export var textDecorationNone = "resourceCard-module--textDecorationNone--b5378";
export var title = "resourceCard-module--title--164ad";